export default __webpack_public_path__ + "static/media/ico_arrow_left_bold.17ff9c94.svg";